import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ProtocolOrderDraft } from '../../services/work-orders.service';
import { TimezoneService } from 'src/app/core/utils/timezone.service';
import { MyAccountService } from 'src/app/core/services/my-account.service';
import { CenterInfo } from 'src/app/core/interfaces/my-workshop/my-account.models';
import { DateFormatLocalizationService } from 'src/app/core/services/date-format-localization.service';

@Component({
    selector: 'app-modal-draft-orders',
    templateUrl: './modal-draft-orders.component.html',
    styleUrls: ['./modal-draft-orders.component.scss'],
})
export class ModalDraftOrdersComponent implements OnInit {
    drafts: ProtocolOrderDraft[] = [];
    centerCountry: string = 'España';

    constructor(
        public dialogRef: MatDialogRef<ModalDraftOrdersComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { drafts: ProtocolOrderDraft[] },
        public translate: TranslateService,
        private timezoneService: TimezoneService,
        private myAccountService: MyAccountService,
        private dateFormatLocalization: DateFormatLocalizationService
    ) { }

    ngOnInit(): void {
        this.drafts = this.data.drafts || [];
        this.loadCenterCountry();
    }

    private loadCenterCountry(): void {
        this.myAccountService.getCenterInfo().subscribe({
            next: (centerInfo: CenterInfo) => {
                this.centerCountry = centerInfo?.country || 'España';
            },
            error: () => {
                this.centerCountry = 'España';
            }
        });
    }

    onContinueDraft(draftId: string): void {
        this.dialogRef.close({ action: 'continue', draftId });
    }

    onCreateNew(): void {
        this.dialogRef.close({ action: 'new' });
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    formatDate(dateString: string): string {
        const localDate = this.timezoneService.convertUtcToLocal(dateString, this.centerCountry);
        return `${this.dateFormatLocalization.formatDate(localDate)} ${localDate.toLocaleTimeString(this.dateFormatLocalization.getCurrentConfig().locale, {
            hour: '2-digit',
            minute: '2-digit'
        })}`;
    }

    getDaysAgo(dateString: string): number {
        const localDate = this.timezoneService.convertUtcToLocal(dateString, this.centerCountry);
        const now = new Date();
        const diffTime = Math.abs(now.getTime() - localDate.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays;
    }
}
